import { useMemo } from 'react';
import { useAcceptanceViewCalendarQuery } from '../../../api/acceptanceViewCalendar';
import {
  searchParamKeys,
  searchParamSelectors,
} from '../../../shared/configs/searchParams';
import { useSearchParamsSelector } from '../../../shared/packages/searchParamsManager';
import { useCalendarManager } from './provider';
import {
  parsedAcceptanceSlugsIsEqual,
  parseAcceptanceSlug,
} from '../../../shared/packages/acceptance';
import { getBaseOptions } from '../helpers';
import {
  toInteger,
  yesNoToBoolean,
} from '../../../shared/packages/searchParamsNormalizer';

const {
  acceptance: acceptanceKey,
  calendarPage: pageKey,
  calendarMode: modeKey,
  showAddress: showAddressKey,
  showClient: showClientKey,
} = searchParamKeys;

const dataTypes = {
  original: 'original',
};

const _options = {
  [dataTypes.original]: {},
};

export const useCalendarViewData = ({
  options,
  dataType = dataTypes.original,
} = {}) => {
  const calendarManager = useCalendarManager();

  const page = useSearchParamsSelector((state) => {
    return toInteger(state[pageKey]);
  });

  const { acceptanceId, houseId } = useSearchParamsSelector((state) => {
    return parseAcceptanceSlug(state[acceptanceKey]);
  }, parsedAcceptanceSlugsIsEqual);

  const mode = useSearchParamsSelector(searchParamSelectors[modeKey]);
  const showClient = useSearchParamsSelector((state) => {
    return yesNoToBoolean(state[showClientKey]);
  });
  const showAddress = useSearchParamsSelector((state) => {
    return yesNoToBoolean(state[showAddressKey]);
  });

  const period = calendarManager.getPeriodAsParams(mode, page);

  const params = useMemo(
    () => ({
      acceptanceId,
      houseId,
      onClients: showClient,
      onAddresses: showAddress,
      ...period,
    }),
    [acceptanceId, houseId, period, showClient, showAddress]
  );

  const baseOptions = getBaseOptions(_options, dataType, dataTypes.original);

  return useAcceptanceViewCalendarQuery({
    params,
    options: { ...baseOptions, ...options },
  });
};

useCalendarViewData.dataTypes = dataTypes;
